<template>
  <v-btn dark small depressed :color="filterDellivery ? 'green' : 'blue-grey lighten-3'" class="mx-1" @click="filter()">
    <v-icon class="mr-1" small>
      {{ filterDellivery ? 'mdi-briefcase-check-outline' : 'mdi-briefcase-clock' }}
    </v-icon>
    {{ filterDellivery ? 'Exibir Entregues' : 'Esconder Entregues' }}
  </v-btn>
</template>

<script>
export default {
  props: {},
  data: () => ({
    filterDellivery: false,
  }),
  methods: {
    filter() {
      this.filterDellivery = !this.filterDellivery
      this.$emit('input', this.filterDellivery)
    },
  },
}
</script>

<style></style>
